import { fromEvent, map, filter } from "rxjs";
import { tabbable } from 'tabbable';
export const TABBABLE_ELEMENT_SELECTOR = 'button, input, a, select';
/**
 * Returns whether the browser settings require reduced/no animations
 *
 */
export function preventAnimation() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches || accessibilityFeaturesEnabled();
}
/**
 * returns an event listener that fires when the accessibility widget indicates it's enabled
 *
 */
export function accessibilityEnabledListener() {
    return fromEvent(window, 'message').pipe(map(message => message.data), filter(data => data === "UsableNetAssistiveEnabled"));
}
/**
 * returns whether the user has enabled accessibility features.
 * can be paired with a listener, as the class might not be applied by the time this method is executed
 * @see {@link accessibilityEnabledListener}
 *
 */
function accessibilityFeaturesEnabled() {
    return document.querySelector('html').classList.contains("un-assistive");
}
export function toggleAccessibleIcon(display) {
    const icon = getAccessibleIcon();
    let isDisplayed;
    if (icon) {
        if (display === 'show') {
            isDisplayed = true;
        }
        else if (display === 'hide') {
            isDisplayed = false;
        }
        else {
            const currentDisplayValue = icon.style.getPropertyValue('display');
            isDisplayed = currentDisplayValue === 'none' ? true : false;
        }
        if (isDisplayed) {
            icon.style.removeProperty('display');
        }
        else {
            icon.style.setProperty('display', 'none', 'important');
        }
    }
}
export function waitForTabbableElements(els) {
    return new Promise((resolve) => {
        const intervalId = setInterval(() => {
            var _a;
            if ((_a = tabbable(els[0])) === null || _a === void 0 ? void 0 : _a.length) {
                clearInterval(intervalId);
                resolve();
            }
        }, 300);
    });
}
function getAccessibleIcon() {
    return document.getElementById('usntA40Toggle');
}
